var _defs, _rect, _rect2, _line, _text, _line2, _text2, _line3, _text3, _line4, _text4, _line5, _text5, _rect3, _text6, _rect4, _text7, _rect5, _text8, _rect6, _text9, _rect7, _rect8, _text10, _rect9, _text11, _rect10, _rect11, _text12, _rect12, _text13, _rect13, _text14, _rect14, _text15, _text16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioPackscheduler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    viewBox: "0 0 1200 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "ah",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#2c2416"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "aa",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#8b6f47"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "hatch",
    width: 14,
    height: 14,
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 14,
    stroke: "#8b6f47",
    strokeWidth: 5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 600,
    fill: "#ece3d2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 40,
    width: 1060,
    height: 513.6,
    fill: "#fdfcfa",
    stroke: "#2c2416",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 100,
    x2: 1130,
    y2: 100,
    stroke: "#2c2416",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 176,
    y: 82,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 30,
    fill: "#6b5d4f",
    textAnchor: "middle",
    letterSpacing: 4
  }, "MON")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 282,
    y1: 40,
    x2: 282,
    y2: 553.6,
    stroke: "#cfc2b1",
    strokeWidth: 2
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 388,
    y: 82,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 30,
    fill: "#6b5d4f",
    textAnchor: "middle",
    letterSpacing: 4
  }, "TUE")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 494,
    y1: 40,
    x2: 494,
    y2: 553.6,
    stroke: "#cfc2b1",
    strokeWidth: 2
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 82,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 30,
    fill: "#6b5d4f",
    textAnchor: "middle",
    letterSpacing: 4
  }, "WED")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 706,
    y1: 40,
    x2: 706,
    y2: 553.6,
    stroke: "#cfc2b1",
    strokeWidth: 2
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 812,
    y: 82,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 30,
    fill: "#6b5d4f",
    textAnchor: "middle",
    letterSpacing: 4
  }, "THU")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 918,
    y1: 40,
    x2: 918,
    y2: 553.6,
    stroke: "#cfc2b1",
    strokeWidth: 2
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 1024,
    y: 82,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 30,
    fill: "#6b5d4f",
    textAnchor: "middle",
    letterSpacing: 4
  }, "FRI")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 130.20000000000005,
    width: 192,
    height: 73.99999999999999,
    fill: "#8b6f47",
    stroke: "#8b6f47",
    strokeWidth: 2
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 172.20000000000005,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#fdfcfa",
    textAnchor: "start"
  }, "CSC 216")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 130.20000000000005,
    width: 192,
    height: 73.99999999999999,
    fill: "#8b6f47",
    stroke: "#8b6f47",
    strokeWidth: 2
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 172.20000000000005,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#fdfcfa",
    textAnchor: "start"
  }, "CSC 216")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 928,
    y: 130.20000000000005,
    width: 192,
    height: 73.99999999999999,
    fill: "#8b6f47",
    stroke: "#8b6f47",
    strokeWidth: 2
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 944,
    y: 172.20000000000005,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#fdfcfa",
    textAnchor: "start"
  }, "CSC 216")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 189,
    width: 192,
    height: 99.20000000000005,
    fill: "#fdfcfa",
    stroke: "#2c2416",
    strokeWidth: 2.5
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 308,
    y: 231,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#2c2416",
    textAnchor: "start"
  }, "CSC 226")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 407.4,
    width: 192,
    height: 132.80000000000007,
    fill: "#fdfcfa",
    stroke: "#2c2416",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 407.4,
    width: 192,
    height: 132.80000000000007,
    fill: "url(#hatch)",
    stroke: "none",
    strokeWidth: 0,
    opacity: 0.3
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 308,
    y: 449.4,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#2c2416",
    textAnchor: "start"
  }, "PY 205")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 716,
    y: 189,
    width: 192,
    height: 99.20000000000005,
    fill: "#fdfcfa",
    stroke: "#2c2416",
    strokeWidth: 2.5
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 231,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#2c2416",
    textAnchor: "start"
  }, "CSC 226")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 716,
    y: 407.4,
    width: 192,
    height: 132.80000000000007,
    fill: "#fdfcfa",
    stroke: "#2c2416",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 716,
    y: 407.4,
    width: 192,
    height: 132.80000000000007,
    fill: "url(#hatch)",
    stroke: "none",
    strokeWidth: 0,
    opacity: 0.3
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 449.4,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#2c2416",
    textAnchor: "start"
  }, "PY 205")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 357,
    width: 192,
    height: 107.60000000000002,
    fill: "#e0d7c8",
    stroke: "#2c2416",
    strokeWidth: 2
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 399,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#2c2416",
    textAnchor: "start"
  }, "MA 241")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 357,
    width: 192,
    height: 107.60000000000002,
    fill: "#e0d7c8",
    stroke: "#2c2416",
    strokeWidth: 2
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 399,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#2c2416",
    textAnchor: "start"
  }, "MA 241")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 184,
    width: 168,
    height: 134.39999999999998,
    fill: "#fdfcfa",
    stroke: "#8b6f47",
    strokeWidth: 4,
    strokeDasharray: "12 9",
    fillOpacity: 0.9
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 954,
    y: 228,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#8b6f47",
    textAnchor: "start"
  }, "CSC 230")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 954,
    y: 270,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 30,
    fill: "#8b6f47",
    textAnchor: "start"
  }, "conflict")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioPackscheduler);
export default __webpack_public_path__ + "static/media/portfolio-packscheduler.c38bcb3d17d9e844ecfe63e22d066f33.svg";
export { ForwardRef as ReactComponent };